module.exports = __webpack_public_path__ + "img/share_new1.4cf77f9e.svg";